module.exports = __webpack_public_path__ + "static/media/TN-Women-Outer.a73528be.svg";